import React, { useState, useEffect } from "react";
import { getDevApplicationState, EditorModes } from "./devApplicationGlobal";
import { dev_event, getDevEmitter } from "./devEvents";

export const EditorTabs = () => {
  const [mode, setMode] = useState(0);
  const [curr_level, setCurrLevel] = useState("");
  const dev = getDevApplicationState();

  useEffect(() => {
    const handler = () => {
      // Default mode
      setMode(0);
    };
    const nameHandler = (lvl: string) => {
      setCurrLevel(lvl);
      handler();
    };
    getDevEmitter()?.addListener(dev_event.EDIT_LEVEL, handler);
    getDevEmitter()?.addListener(dev_event.LEVEL_TRACKER, nameHandler);
    return () => {
      getDevEmitter()?.removeListener(dev_event.EDIT_LEVEL, handler);
      getDevEmitter()?.removeListener(dev_event.LEVEL_TRACKER, nameHandler);
    };
  }, []);

  return (
    <>
      <h3>Level: {curr_level}</h3>
      <ul className="modeTabs">
        <li
          className={mode === 0 ? "active" : ""}
          onClick={() => {
            if (mode !== 0) {
              dev?.saveLevel();
              setTimeout(() => dev?.changeMode(EditorModes.Play), 20);
            }
            setMode(0);
          }}
        >
          Play
        </li>
        <li
          className={mode === 1 ? "active" : ""}
          onClick={() => {
            if (mode !== 1) {
              dev?.changeMode(EditorModes.Edit);
            }
            setMode(1);
          }}
        >
          Edit Level
        </li>
        {mode === 1 ? (
          <li
            onClick={() => {
              console.log("we are here");
              dev?.saveLevel(true);
            }}
          >
            Save lvl as File
          </li>
        ) : null}
      </ul>
    </>
  );
};
